export const GetApiErrorMessage = (error: any): string => {
  const { status, data } = error?.response ?? {}

  if (status === 400 && data) {
    const messages = data?.File ?? data?.errors?.File ?? data?.errors?.[''] ?? data?.title ?? data

    if (Array.isArray(messages)) return messages.join('; ')
    if (typeof messages === 'string') return messages
  }

  return data?.title
}
